import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "../../../context/AuthContext";

// Adult post-signup consents retain the existing flow. GuardianGate handles
// minors using persisted server verification on signup and later sessions.
const ConsentGate = () => {
  const { pendingConsentData } = useAuth();

  if (pendingConsentData && !pendingConsentData.isMinor) {
    return <Navigate to="/athlete/consent" replace />;
  }

  return <Outlet />;
};

export default ConsentGate;
